var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.13772 6.85674L9.1506 12.853C9.34761 13.0493 9.66656 13.049 9.86324 12.852C10.0598 12.655 10.0593 12.3358 9.86222 12.1393L4.20725 6.49998L9.86243 0.860641C10.0594 0.664118 10.0599 0.345187 9.86344 0.148157C9.76485 0.0493879 9.63569 2.82826e-06 9.50653 2.81696e-06C9.3777 2.8057e-06 9.24904 0.0490569 9.15063 0.14714L3.13772 6.14324C3.04284 6.23764 2.98959 6.36612 2.98959 6.49998C2.98959 6.63384 3.04299 6.76216 3.13772 6.85674Z",
    fill: "#272D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(13 13) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousIcon);
export default __webpack_public_path__ + "static/media/previousIcon.22948844c28a3a483ff16adbd8e02084.svg";
export { ForwardRef as ReactComponent };